/**
 * @module components/Feedback/UserFeedback
 * @author Charles Blais <charles.blais@canada.ca>
 */
import AlertLoading from './alert-loading';
import AlertError from './alert-error';
import ZonesAdvisory from './zones-advistory';


type Props = {
  isLoading: boolean,
  isError: boolean,
  data: SiteDesignationsXVResponse | SiteDesignationsXSResponse,
}


/**
 * React component
 * ===============
 */
const UserFeedback = ({
  data,
  isLoading = false,
  isError = false,
}: Props) => {
  if( isLoading ) {
    return ( <AlertLoading /> );
  }
  if( isError ) {
    return ( <AlertError /> );
  }
  const isEmpty = !(data && Object.keys(data).length);
  const zones = (isEmpty) ? [] : data.metadata.zones;
  return ( <ZonesAdvisory zones={zones} /> );
}

export default UserFeedback;